import { createSelector } from 'reselect';

const selectUser = (state) => state.admin;

export const selectAdminUser = createSelector([selectUser], (state) => state.user);
export const selectAdminToken = createSelector([selectUser], (state) => state.token);
